<template>
  <div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form :form="form" layout="inline">
        <standard-form-row :title="$t('business.label.category')" block style="padding-bottom: 11px;">
          <a-form-item>
            <a-checkable-tag v-for="item in tags" :key="item.value" v-if="item.visible" v-model="item.selected" @change="handleChange">{{ item.name }}</a-checkable-tag>
          </a-form-item>
        </standard-form-row>

        <div class="ant-pro-pages-list-projects-cardList">
          <a-list :loading="loading" :data-source="menus" :grid="{ gutter: 6, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }">
            <a-list-item slot="renderItem" slot-scope="item" @click="open(item)">
              <a-card class="ant-pro-pages-list-projects-card" hoverable>
                <a-card-meta :title="$t(item.internalName)" style="{text-align:center}">
                </a-card-meta>
                <div class="cardItemContent">
                  <div class="avatarList">
                    <avatar-list size="large">
                      <avatar-list-item
                        v-for="(member, i) in item.members"
                        :key="`${item.no}-avatar-${i}`"
                        :src="member.avatar"
                        :tips="member.name"
                      />
                    </avatar-list>
                  </div>
                </div>
              </a-card>
            </a-list-item>
          </a-list>
        </div>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import { StandardFormRow, AvatarList } from '@/components'
import IconText from './components/IconText'
import Vue from 'vue'
import { OPERATOR } from '@/store/mutation-types'

const AvatarListItem = AvatarList.AvatarItem

export default {
  components: {
    StandardFormRow,
    IconText,
    AvatarList,
    AvatarListItem
  },
  data() {
    return {
      //owners,
      loading: true,
      loadingMore: false,
      data: [],
      form: this.$form.createForm(this),
      menus: [],
      userMenus:[],
      tags: [
        { selected: false, value: 'dashboard', name: this.$t('menu.dashboard'), visible: false },
        { selected: false, value: 'basedata', name: this.$t('menu.baseData'), visible: false },
        { selected: false, value: 'inbound', name: this.$t('menu.inbound'), visible: false },
        { selected: false, value: 'outbound', name: this.$t('menu.outbound'), visible: false },
        { selected: false, value: 'warehouseManagement', name:this.$t('menu.warehouseManagement'), visible: false },
        { selected: false, value: 'qualityControl', name: this.$t('menu.qualityControl'), visible: false },
        { selected: false, value: 'authorityManage', name: this.$t('menu.authorityManage'), visible: false },
        { selected: false, value: 'config', name: this.$t('menu.configuration'), visible: false },
        { selected: false, value: 'query', name: this.$t('menu.query'), visible: false },
        { selected: false, value: 'other', name: this.$t('menu.others'), visible: false }
      ],
      operator: null
    }
  },
  mounted() {
    this.operator=Vue.ls.get(OPERATOR)
    this.operator.menus
      .filter(m => m.leaf && m.available && m.functional && m.application === 1 && m.parameter !== null)
      .forEach(menu=>{
         let parameter=JSON.parse(menu.parameter)
         if (parameter!==null && parameter.meta && parameter.meta.title){
           menu['internalName']=parameter.meta.title
         }
         this.userMenus.push(menu)
      })
    this.getList()
  },
  methods: {
    handleChange() {
      this.getList()
    },
    getList() {
      this.loading = true
      if (this.tags.filter(t => t.selected).length === 0) {
        this.menus = this.userMenus
      } else {
        this.menus = this.userMenus.filter(m =>this.tags.filter(t => t.selected && JSON.stringify(m.url).includes(t.value)).length > 0)
      }
      this.tags.forEach(t => {
        if (this.menus.filter(r => JSON.stringify(r.url).includes(t.value)).length > 0) {
          t.visible = true
        }
      })
      this.loading = false
    },
    // loadMore () {
    //   this.loadingMore = true
    //   this.$http.get('/list/article').then(res => {
    //     this.data = this.data.concat(res.result)
    //   }).finally(() => {
    //     this.loadingMore = false
    //   })
    // },
    open(item) {
      this.$router.push({ name: item.no })
    },
    search(text) {
      if (text === '*') {
        this.getList()
      } else {
        this.menus = this.menus.filter(m => m.name.includes(text))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ant-pro-components-tag-select {
  /deep/ .ant-pro-tag-select .ant-tag {
    margin-right: 24px;
    font-size: 14px;
  }
}

.list-articles-trigger {
  margin-left: 12px;
}
</style>
